import _slicedToArray from "/codebuild/output/src1787262798/src/tpp-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import * as e from "react";
import { getMediaQueries as t } from "./getMediaQueries.js";

var n = "undefined" == typeof window ? e.useEffect : e.useLayoutEffect,
    o = function o(_ref) {
  var o = _ref.breakpoints,
      a = _ref.defaultBreakpoint;

  var r = "undefined" != typeof window && void 0 !== window.matchMedia ? window.matchMedia : null,
      i = e.useMemo(function () {
    return t({
      breakpoints: o
    });
  }, [o]),
      _e$useState = e.useState(a),
      _e$useState2 = _slicedToArray(_e$useState, 2),
      s = _e$useState2[0],
      u = _e$useState2[1],
      c = e.useCallback(function (e, t) {
    e && u(t);
  }, [u]);

  return n(function () {
    if (!r) return;
    var e = i.map(function (_ref2) {
      var e = _ref2.query,
          t = _ref2.breakpoint;
      var n = r(e);
      c(n.matches, t);

      var o = function o(e) {
        e.matches && u(t);
      };

      return n.addEventListener("change", o), function () {
        return n.removeEventListener("change", o);
      };
    });
    return function () {
      e.forEach(function (e) {
        return e();
      });
    };
  }, [o, u, r, i]), e.useDebugValue(s, function (e) {
    return e;
  }), s;
};

export { o as useBreakpoint };